export const costingno = (costingno) => ({
  type: "SET_SELECTED_COSTINGNO",
  payload: costingno,
});
